import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  acceptRequest,
  cancelRequest,
  deleteRequest,
  addFriend,
  unfriend,
  unfollow,
  unblockUser,
  addToFavorites,
} from "../../functions/user";

export default function Card({ userr, type, getData }) {
  const { user } = useSelector((state) => ({ ...state }));
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [loading, setLoading] = useState(false);

  const cancelRequestHandler = async (userId) => {
    setLoading(true);
    const res = await cancelRequest(userId, user.token);
    if (res === "ok") {
      getData();
    }
    setLoading(false);
  };

  const confirmHandler = async (userId) => {
    setLoading(true);
    const res = await acceptRequest(userId, user.token);
    if (res === "ok") {
      getData();
    }
    setLoading(false);
  };

  const deleteHandler = async (userId) => {
    setLoading(true);
    const res = await deleteRequest(userId, user.token);
    if (res === "ok") {
      getData();
    }
    setLoading(false);
  };

  const addFriendHandler = async (userId) => {
    setLoading(true);
    const res = await addFriend(userId, user.token);
    if (res === "ok") {
      getData();
    }
    setLoading(false);
  };

  const unfriendHandler = async (userId) => {
    setLoading(true);
    const res = await unfriend(userId, user.token);
    if (res === "ok") {
      getData();
    }
    setLoading(false);
  };

  const unfollowHandler = async (userId) => {
    setLoading(true);
    const res = await unfollow(userId, user.token);
    if (res === "ok") {
      getData();
    }
    setLoading(false);
  };

  const unblockHandler = async (userId) => {
    setLoading(true);
    const res = await unblockUser(userId, user.token);
    if (res === "ok") {
      getData();
    }
    setLoading(false);
  };

  const addToFavoritesHandler = async (userId) => {
    const res = await addToFavorites(userId, user.token);
    if (res === "ok") {
      setShowMenu(false);
    }
  };

  return (
    <div className="req_card">
      <Link to={`/profile/${userr.username}`}>
        <img src={userr.picture} alt="" />
        {userr.isOnline && <div className="online_indicator"></div>}
      </Link>
      <div className="req_name">
        {userr.first_name} {userr.last_name}
      </div>
      {userr.mutualFriendsCount > 0 && (
        <div className="mutual_friends_count">
          {userr.mutualFriendsCount} mutual friend{userr.mutualFriendsCount > 1 ? "s" : ""}
        </div>
      )}

      {type === "sent" ? (
        <button
          className="blue_btn"
          onClick={() => cancelRequestHandler(userr._id)}
          disabled={loading}
        >
          {loading ? "..." : "Cancel Request"}
        </button>
      ) : type === "request" ? (
        <>
          <button
            className="blue_btn"
            onClick={() => confirmHandler(userr._id)}
            disabled={loading}
          >
            {loading ? "..." : "Confirm"}
          </button>
          <button
            className="gray_btn"
            onClick={() => deleteHandler(userr._id)}
            disabled={loading}
          >
            Delete
          </button>
        </>
      ) : type === "friends" ? (
        <div className="card_buttons">
          <button
            className="blue_btn"
            onClick={() => navigate(`/chat/${userr._id}`)}
          >
            Message
          </button>
          <div className="card_menu_wrap">
            <button
              className="gray_btn icon_btn"
              onClick={() => setShowMenu(!showMenu)}
            >
              <i className="dots_icon"></i>
            </button>
            {showMenu && (
              <div className="card_menu">
                <div className="card_menu_item" onClick={() => addToFavoritesHandler(userr._id)}>
                  Add to Favorites
                </div>
                <div className="card_menu_item" onClick={() => unfriendHandler(userr._id)}>
                  Unfriend
                </div>
                <div className="card_menu_item" onClick={() => unfollowHandler(userr._id)}>
                  Unfollow
                </div>
              </div>
            )}
          </div>
        </div>
      ) : type === "follower" ? (
        <div className="card_buttons">
          <button
            className="blue_btn"
            onClick={() => addFriendHandler(userr._id)}
            disabled={loading}
          >
            {loading ? "..." : "Add Friend"}
          </button>
          <button
            className="gray_btn"
            onClick={() => navigate(`/profile/${userr.username}`)}
          >
            View
          </button>
        </div>
      ) : type === "following" ? (
        <button
          className="gray_btn"
          onClick={() => unfollowHandler(userr._id)}
          disabled={loading}
        >
          {loading ? "..." : "Unfollow"}
        </button>
      ) : type === "suggestion" ? (
        <div className="card_buttons">
          <button
            className="blue_btn"
            onClick={() => addFriendHandler(userr._id)}
            disabled={loading}
          >
            {loading ? "..." : "Add Friend"}
          </button>
          <button
            className="gray_btn"
            onClick={() => navigate(`/profile/${userr.username}`)}
          >
            View
          </button>
        </div>
      ) : type === "blocked" ? (
        <button
          className="blue_btn"
          onClick={() => unblockHandler(userr._id)}
          disabled={loading}
        >
          {loading ? "..." : "Unblock"}
        </button>
      ) : (
        ""
      )}
    </div>
  );
}
